import React from "react";
import { Dialog, DialogContent, Stack } from "@mui/material";
// import { Transition } from "../Transition/Transition";
import Fade from "@mui/material/Fade";

import "./FinalPopup.scss";

const FinalPopup = ({ open, message }) => {
  return (
    <Dialog
      open={open}
      className="final-overlay-dialog"
      sx={{
        "& .MuiDialog-paper": {
          backgroundColor: "transparent",
          backdropFilter: "blur(24px)",
          width: "1280px",
          height: "860px",
        },
        "& .MuiBackdrop-root": {
          backgroundColor: "none", // Change backdrop color
        },
      }}
      maxWidth={false}
      TransitionComponent={Fade}
      keepMounted
      disablePortal
    >
      <Stack className="dotted-background">
        <DialogContent>
          <div className="final-overlay-dialog">
            <div className="pause-text-box">
              <p>{message}</p>
            </div>
          </div>
        </DialogContent>
      </Stack>
    </Dialog>
  );
};

export default FinalPopup;
